<template>
    <v-tooltip eager style="display: none" bottom>
      <template v-slot:activator="{ on }">
        <button
          @click="$emit('click')"
          :class="!closeIcon ? 'outline-rounded-button mr-1' : 'rounded-button mr-1'"
          v-on="on"
          :name="name"
        >
            <icon
                :name="iconName"
                :size="iconSize"
            />
        </button>
      </template>
      <span> {{tooltipName ? tooltipName : nameTooltip}} </span>
    </v-tooltip>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      required: false,
      default: ''
    },
    iconSize: {
      type: Number,
      required: false,
      default: 0
    },
    tooltipName: {
      type: String,
      required: false
    },
    name: {
      type: String,
      default: ''
    },
    closeIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    nameTooltip () {
      switch (this.iconName) {
        case 'eye':
          return 'Visualizar'
        case 'edit':
          return 'Editar'
        case 'trash':
        case 'x':
          return 'Excluir'
        case 'download':
          return 'Download'
        case 'paperclip':
          return 'Anexo'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.outline-rounded-button
  border: #00995D 1px solid
  border-radius: 50px
  color: #00995D
  height: 26px
  width: 26px
  padding: 4px 4px
  transition: opacity .3s, background .3s
  &:hover
    opacity: 0.7
  &:active
    background: #00995E
    color: white

.rounded-button
  border: #00995D 0px solid
  border-radius: 50px
  color: #00995D
  height: 26px
  width: 26px
  padding: 5px 5px
  transition: opacity .3s, background .3s
  &:hover
    opacity: 0.7
  &:active
    background: #00995E
    color: white
</style>
